<script>
    import {Link} from "svelte-routing";
    import {store} from '../stores.js';

    const user = store('credentials', 'appUserAuth');
    const dark_mode = store('dark_mode', null, 0);

    // on load
    document.body.classList.toggle('dark-mode-active', $dark_mode);
    
    const handlerDarkMode = () => {
        dark_mode.save($dark_mode ? 0 : 1);
        document.body.classList.toggle('dark-mode-active', $dark_mode);
    };
    
    const logout = () => {
        user.remove();
    };
    
    const popstate = () => {
        document.querySelector('.close-sidebar-button').click();
    };
</script>

<!-- App Sidebar -->
<div class="offcanvas offcanvas-start" tabindex="-1" id="sidebarPanel">
    <div class="offcanvas-body">
        <!-- profile box -->
        <div class="profileBox">
            <div class="in">
                <strong>Личный кабинет</strong>
            </div>
            <a href="#" class="close-sidebar-button" data-bs-dismiss="offcanvas">
                <ion-icon name="close"></ion-icon>
            </a>
        </div>
        <!-- * profile box -->
        
        <ul class="listview flush transparent no-line image-listview mt-2">
            {#if $user.idRegPred > 0}
                <li>
                    <Link to="/panel" class="item" on:click={popstate}>
                        <div class="icon-box bg-primary">
                            <ion-icon name="home-outline"></ion-icon>
                        </div>
                        <div class="in">
                            Панель
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/products" class="item" on:click={popstate}>
                        <div class="icon-box bg-primary">
                            <ion-icon name="cube-outline"></ion-icon>
                        </div>
                        <div class="in">
                            Продукты
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/activity" class="item" on:click={popstate}>
                        <div class="icon-box bg-primary">
                            <ion-icon name="calendar-outline"></ion-icon>
                        </div>
                        <div class="in">
                            Мероприятия
                        </div>
                    </Link>
                </li>
            {/if}
            
            {#if $user.id > 0}
                <li>
                    <Link to="/dashboard" class="item" on:click={popstate}>
                        <div class="icon-box bg-primary">
                            <ion-icon name="home-outline"></ion-icon>
                        </div>
                        <div class="in">
                            Кабинет
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/events" class="item" on:click={popstate}>
                        <div class="icon-box bg-primary">
                            <ion-icon name="calendar-outline"></ion-icon>
                        </div>
                        <div class="in">
                            Мероприятия
                        </div>
                    </Link>
                </li>
                {#if $user.certs > 0}
                    <li>
                        <Link to="/cert" class="item" on:click={popstate}>
                            <div class="icon-box bg-primary">
                                <ion-icon name="medal-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Сертификаты
                            </div>
                        </Link>
                    </li>
                {/if}
                <li>
                    <Link to="/member" class="item" on:click={popstate}>
                        <div class="icon-box bg-primary">
                            <ion-icon name="person-outline"></ion-icon>
                        </div>
                        <div class="in">
                            Анкета участника
                        </div>
                    </Link>
                </li>
            {/if}
        </ul>
    
        <ul class="listview flush transparent no-line image-listview position-absolute" style="bottom: 56px; width: 100%;">
            <li>
                <div class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="moon-outline" role="img" class="md hydrated" aria-label="moon outline"></ion-icon>
                    </div>
                    <div class="in">
                        <div>Ночной режим</div>
                        <div class="form-check form-switch">
                            <input class="form-check-input dark-mode-switch" type="checkbox" id="darkmodesidebar" on:change={handlerDarkMode} checked={$dark_mode}>
                            <label class="form-check-label" for="darkmodesidebar"></label>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    
    <!-- sidebar buttons -->
    <div class="sidebar-buttons">
        <Link to="/" class="button" on:click={popstate} on:click={logout}>
            <ion-icon name="log-out-outline"></ion-icon>
        </Link>
    </div>
    <!-- * sidebar buttons -->
</div>
<!-- * App Sidebar -->
